import axios, { AxiosRequestConfig } from 'axios';
import {
  REACT_APP_IS_SIEMENS_BRANDING_URL,
  REACT_APP_API_URL,
  REACT_APP_SIEMENS_API_URL,
} from './configs';

export class Authorization {
  static accessToken: string = '';
}

export async function assignAccessToken(config) {
  config.headers.Authorization = Authorization.accessToken
    ? `Bearer ${Authorization.accessToken}`
    : '';
  return config;
}

const fetchClient = () => {
  const defaultOptions: AxiosRequestConfig = {
    baseURL: REACT_APP_IS_SIEMENS_BRANDING_URL
      ? REACT_APP_SIEMENS_API_URL
      : REACT_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const instance = axios.create(defaultOptions);

  // Set the AUTH token for every request
  instance.interceptors.request.use(assignAccessToken);

  return instance;
};

export default fetchClient();
